import {
  HealthCare,
  Housing,
  LegacyGoals,
  Lifestyle,
  SocialSecurity,
  Taxes,
} from 'component-library/components/icons';
import { Flex, FlexProps } from 'component-library/components/layout/Flex';
import { Body } from 'component-library/components/typography/Body';
import { Subheading } from 'component-library/components/typography/Subheading';
import { colors } from 'component-library/styles/colors';
import React, { FC } from 'react';
import styled from 'styled-components';

const StyledFlex = styled(Flex)`
  background: ${colors.greenLight};
  border-radius: 24px;
  padding: 40px;
`;

export enum OptionVariant {
  SocialSecurity = 'SocialSecurity',
  HealthCare = 'HealthCare',
  Taxes = 'Taxes',
  Housing = 'Housing',
  LegacyGoals = 'LegacyGoals',
  Lifestyle = 'Lifestyle',
}

const options = {
  [OptionVariant.SocialSecurity]: {
    Icon: SocialSecurity,
    heading: 'Social Security',
    body: 'See when to elect and how much to expect.',
  },
  [OptionVariant.HealthCare]: {
    Icon: HealthCare,
    heading: 'Health Care',
    body: 'Anticipate your changing needs and costs.',
  },
  [OptionVariant.Taxes]: {
    Icon: Taxes,
    heading: 'Taxes',
    body: 'Use our expert strategies to help avoid unexpected bills.',
  },
  [OptionVariant.Housing]: {
    Icon: Housing,
    heading: 'Housing',
    body: 'Create a plan around your decision to move or stay.',
  },
  [OptionVariant.LegacyGoals]: {
    Icon: LegacyGoals,
    heading: 'Legacy Goals',
    body: 'Set financial goals to gift to your loved ones.',
  },
  [OptionVariant.Lifestyle]: {
    Icon: Lifestyle,
    heading: 'Lifestyle',
    body: 'Incorporate plans for travel, projects, and more.',
  },
};

interface OptionProps extends FlexProps {
  optionVariant: OptionVariant;
}

export const Option: FC<OptionProps> = ({ optionVariant, ...rest }) => {
  const { Icon, heading, body } = options[optionVariant];

  return (
    <StyledFlex column {...rest}>
      <Icon />
      <Subheading variant={2} marginBottom={12} marginTop={64}>
        {heading}
      </Subheading>
      <Body variant={3}>{body}</Body>
    </StyledFlex>
  );
};
